<style>
.el-collapse-item__header {
  padding-left: 15px;
}

.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}

.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}

.v-modal {
  z-index: 100 !important;
}

.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}

.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}

.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}

.operate-btns {
  display: flex;
  justify-content: center;
}

.reject-btn.btn {
  background: #FFF2F4;
  border: 1px solid rgba(255, 219, 224, 1);
  border-radius: 2px;
  color: #FB2323;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;

}

.pass-btn.btn {
  background: #F2FFF5;
  border: 1px solid rgba(220, 250, 228, 1);
  border-radius: 2px;
  color: #1BA854;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}

.ing-btn.btn {
  background: #FFFBF2;
  border: 1px solid rgba(255, 241, 212, 1);
  border-radius: 2px;
  color: #FF991C;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}

.cancel-btn.btn {
  background: #F5F5F5;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  color: #666;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}
</style>
<template>
  <div class="content" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="search-area-div">产品类别</div>
          <el-select multiple size="mini" class="ipt-sty" v-model="page.productCategoryList" filterable placeholder="请选择产品类别">
            <el-option v-for="item in getCodeListByKey('超级模版-对应产品类别')" :key="item.value" :label="item.text"
                :value="item.value"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">任务类别</div>
          <el-select size="mini" class="ipt-sty" v-model="page.taskCategory" filterable placeholder="请选择任务类别">
            <el-option  v-for="item in getCodeListByKey('任务类别')" :key="item.value" :label="item.text"
                :value="item.value"></el-option>
           </el-select>
        </el-col>
       
        <el-col :span="6">
          <div class="search-area-div">执行时间</div>
          <el-date-picker size="mini" class="ipt-sty" v-model="timeRange" type="daterange" align="left" unlink-panels
            range-separator="-" start-placeholder="起始时间" end-placeholder="截止时间" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-col>
        <el-col :span="6" class="search-btn-box">
          <el-button size="mini" type="text" @click="showMore = !showMore"
            :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'">
          {{ showMore ? '收起筛选' : '更多筛选' }}
        </el-button>
        <el-button size="mini" type="info" @click="search">搜索</el-button>
        <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
      </el-col>
    </el-row>
    <el-row :gutter="24" class="mt15" v-show="showMore">
      <el-col :span="6">
        <div class="search-area-div">审批状态</div>
            <el-select multiple  size="mini" v-model="page.approveStateList" filterable placeholder="请选择审批状态" class="ipt-sty" >
              <el-option v-for="item in approvalStateList" :key="item.value" :label="item.label" :value="item.value"></el-option> 
            </el-select>
          </el-col>
        <el-col :span="6">
          <div class="search-area-div">执行状态</div>
          <el-select size="mini" class="ipt-sty" v-model="page.taskExecuteState" filterable placeholder="请选择执行状态">
            <el-option v-for="item in taskExecuteStateList" :key="item" :label="item" :value="item"></el-option> </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">任务状态</div>
          <el-select multiple  size="mini" class="ipt-sty" v-model="page.stateList" filterable placeholder="请选择任务包状态">
            <el-option v-for="item in stateList" :key="item" :label="item" :value="item"></el-option> </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div w90">是否关联项目</div>
          <el-select    size="mini" class="ipt-sty" v-model="page.isRelProject" filterable placeholder="请选择是否关联项目">
            <el-option v-for="item in RelProjectOption" :key="item" :label="item.label" :value="item.value"></el-option> </el-select>
        </el-col>
      </el-row>
    </div>

    <div class="back-color-fff content-main-box" :style="'height:' + contentMainHeight + 'px;'">
      <div class="button-area">
        <el-button icon="el-icon-plus" size="mini" type="info" @click="addVersion">配置任务包</el-button>
      </div>
      <el-table :data="tableData" :height="tableHeight" stripe border style="width: 100%" v-loading="tableLoading">
        <el-table-column fixed="left" label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="taskNo" width="120" label="任务包编号" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.taskNo }}</template>
        </el-table-column>
        <el-table-column fixed="left" prop="taskTitle" width="320" label="任务标题" show-overflow-tooltip
          header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.taskTitle || '-' }}</template>
        </el-table-column>
     
        <el-table-column prop="campaignsState" width="210" label="执行时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.startTime | getDate }} 至 {{
            scope.row.endTime | getDate
          }}</template>
        </el-table-column>

        <el-table-column prop="createUserName" width="96" label="任务内容" header-align="center" align="left">
          <template slot-scope="scope">共{{ scope.row.taskDetailCount }}项目</template>
        </el-table-column>
        <el-table-column prop="state"  width="96" label="任务包状态" header-align="center"
          align="left">
          <template slot-scope="scope">{{ scope.row.state }}</template>
        </el-table-column>

  
        <el-table-column prop="state" :render-header="renderHeader"  width="96" label="是否置顶" header-align="center"
          align="left">
          <template slot-scope="scope">{{ scope.row.isTop=='Y'?'是': scope.row.isTop=='N'?'否':'-'}}</template>
        </el-table-column>
        <el-table-column  width="96"  label="审批状态" header-align="center" align="center">
          <template slot-scope="scope">
              <a class="reject-btn btn" v-if="scope.row.approveVO.approveState == 'R'">已驳回</a>
              <a class="pass-btn btn" v-if="scope.row.approveVO.approveState == 'Y'">已通过</a>
              <a class="ing-btn btn" v-if="scope.row.approveVO.approveState == 'A'">审批中</a>
              <a class="cancel-btn btn" v-if="scope.row.approveVO.approveState == 'C'">已撤销</a>
              <a class="cancel-btn btn" v-if="scope.row.approveVO.approveState == 'N'">草稿中</a>
          </template>
        </el-table-column>

        <el-table-column prop="taskExecuteState" width="110" label="业务执行状态" header-align="center" align="left">
        </el-table-column>
        <el-table-column prop="state"  width="140" label="置顶时间" header-align="center"
          align="left">
          <template slot-scope="scope">{{ scope.row.topDateTime| getTime }}</template>
        </el-table-column>
  
        <el-table-column prop="bank" min-width="230px" label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- 草稿中 -->
            <div v-if="scope.row.approveVO.approveState == 'N'">
              <a class="txt-color" @click="editForm(scope.row)">编辑 ｜</a>
              <a class="txt-color" @click="delForm(scope.row.guid)">删除</a>
            </div>
            <!--已驳回 已撤销  -->
            <div v-if="scope.row.approveVO.approveState == 'R' || scope.row.approveVO.approveState == 'C'">
              <a class="txt-color" v-if="scope.row.approveVO.staffGuid == staffGuid && scope.row.bizApproveState != 'D'"
                @click="editForm(scope.row)">重新提交｜</a>
              <a class="txt-color" v-else @click="seeForm(scope.row,1)">详情<span  v-if="scope.row.approveVO.staffGuid == staffGuid" >｜</span></a>
              <a class="txt-color"  v-if="scope.row.approveVO.staffGuid == staffGuid" @click="delForm(scope.row.guid)">删除</a>
            </div>

            <!-- 已通过 -->
            <div v-if="scope.row.approveVO.approveState == 'Y'">
              <a class="txt-color" @click="addCustomer(scope.row)">维护客户/项目｜</a>
              <a class="txt-color" v-if="scope.row.hasNewTenant == '1'" @click="seeCustomer(scope.row)">查看｜</a>
              <a class="txt-color" @click="seeForm(scope.row, 1)">详情</a>
              <a class="txt-color" v-if="scope.row.taskCategory == '2'"  @click="seeForm(scope.row, 2)">｜执行情况</a>
              <template v-if="scope.row.approveVO.staffGuid == staffGuid">
                <a class="txt-color" v-if="scope.row.taskCategory == '2' && scope.row.state != '已失效' && scope.row.taskExecuteState != '已结束' && scope.row.isTop != 'Y'" @click="setTop(scope.row.guid, 'Y')">｜设置置顶</a>
                <a class="txt-color" v-if="scope.row.taskCategory == '2' && scope.row.state != '已失效' && scope.row.taskExecuteState != '已结束' && scope.row.isTop == 'Y'" @click="setTop(scope.row.guid, 'N')">｜取消置顶</a>
                <a class="txt-color" v-if="scope.row.taskCategory == '2' && scope.row.state != '已失效' && scope.row.taskExecuteState != '已结束'" @click="setIvalidityState(scope.row)">｜设为失效</a>
                <a class="txt-color" v-if="scope.row.taskCategory == '1' && scope.row.taskExecuteState == '已结束'" @click="openReportDialog(scope.row)">｜上传运营报告</a>
              </template>
              <a class="txt-color" v-if="haveReportFile(scope.row)" @click="onPreview(haveReportFile(scope.row))">｜查看运营报告</a>
            </div>

            <!-- 审批中 -->
            <div v-if="scope.row.approveVO.approveState == 'A'">
              <a class="txt-color" v-if="scope.row.approveVO.staffGuid == staffGuid" @click="toRevoke(scope.row)">撤销｜</a>
              <a class="txt-color" v-if="scope.row.approveVO.approveStaffGuids.indexOf(staffGuid) > -1"
                @click="passDialogVisible = true; approveSuggest = ''; detail = scope.row;">通过｜</a>
              <a class="txt-color" v-if="scope.row.approveVO.approveStaffGuids.indexOf(staffGuid) > -1"
                @click="rejectDialogVisible = true; approveSuggest = ''; detail = scope.row;">驳回｜</a>
              <a class="txt-color" @click="seeForm(scope.row,1)">详情</a>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination class="pt pb back-color-fff content-pagination-box" background @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100, 200]" :current-page="page.pageIndex"
      :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.totalRows">
    </el-pagination>
    <el-dialog title="驳回流程" :visible.sync="rejectDialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" placeholder="输入驳回理由（必填）" maxlength="100" v-model="approveSuggest"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toRejectSubmit()">驳回</el-button>
      </span>
    </el-dialog>
    <el-dialog title="填写通过备注" :visible.sync="passDialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" maxlength="100" placeholder="请填写通过备注（选填）" v-model="approveSuggest"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toPassSubmit()">通过</el-button>
      </span>
    </el-dialog>
    <el-dialog title="运营报告" :visible.sync="reportDialogVisible" width="680px">
      <el-form v-if="reportDialogVisible" label-width="100px" :label-position="right" class="demo-ruleForm">
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">运营报告：</span>
          <el-upload
            class="upload-demo fl t-left"
            action="#"
            multiple
            :limit="1"
            accept=".pdf,.PDF,.docx,doc"
            :on-exceed="handleExceed"
            :http-request="uploadFile"
            :file-list="detail.reportFileList"
            :beforeUpload="beforeAvatarUpload"
          >
          <div class="file-operate" slot="file" slot-scope="{ file }">
            <div class="file-name">{{ file.name }}</div>
            <div class="file-preview" @click="onPreview(file)">查看</div>
            <div class="file-preview" @click="onDownload(file)">下载</div>
            <div class="file-preview" @click="handleRemove(file)">删除</div>
          </div>
          <div class="import-btn-tips" style="text-align:left;">
            <el-button size="mini" icon="el-icon-my-import" type="importNew">导入文件</el-button>
            <div class="import-step-tip"> 当前支持 word、pdf，请使用 Office 2010 及以上版本，否则可能出现乱码，单个文件不得大于20M</div>
          </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" plain @click="reportDialogVisible = false">取 消</el-button>
        <el-button size="medium" type="info" @click="uploadReport" v-loading.fullscreen.lock="fullscreenLoading">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="addCustomerTitle" :visible.sync="addDialogVisible" width="500px" top="15%">
      <el-form v-if="addCustomerTitle=='新增客户'" label-width="140px" :label-position="right" class="demo-ruleForm">
        <el-form-item>
          <span slot="label">新增客户： </span>
          <el-select class="fl" v-model="tenantTagList"
            placeholder="请选择" filterable multiple>
              <el-option v-for="(item, index) in sendTenantList" :key="index" :label="item.tenantTag"
              :value="item.tenantGuid"></el-option> 
          </el-select>
        </el-form-item>
        <el-form-item>
          <span slot="label">关联研发项目： </span>
          <el-select class="fl" v-model="projectList"
          collapse-tags
            placeholder="请选择" filterable multiple>
              <el-option v-for="(item, index) in projectOption" :key="guid" :label="item.name"
              :value="item.guid"></el-option> 
          </el-select>
        </el-form-item>
      </el-form>
      <div v-else>
        <div>{{ getBillCycleName(taskExecuteTenantList) }}</div>
      </div>
      
      <span v-if="addCustomerTitle=='新增客户'" slot="footer" class="dialog-footer">
        <el-button size="mini" plain @click="addDialogVisible=false;detail={reportFileList:[]}">取消</el-button>
        <el-button size="mini" type="info" @click="toAddSubmit()">确认</el-button>
      </span>
      <span v-else slot="footer" class="dialog-footer">
        <el-button size="mini" plain @click="addDialogVisible=false;detail={reportFileList:[]}">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment';
import { IsRelProjectEnum, RelProjectOption } from './enum'
export default {
  data() {
    let userinfo = JSON.parse(localStorage.userInfo);
    return {
      IsRelProjectEnum,
      RelProjectOption,
      urlImg: `/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
      reportDialogVisible:false,
      detail:{
        reportFileList:[]
      },
      userGuid: userinfo.userGuid,
      rejectDialogVisible: false,
      passDialogVisible: false,
      addDialogVisible: false,
      approveSuggest: '',
      staffGuid: userinfo.staffGuid,
      showMore: false, // 筛选项显示更多，默认否，最多显示三个
      tableHeight: window.innerHeight - 263,
      contentMainHeight: window.innerHeight - 200,
      fullscreenLoading: false,
      textTitle: '配置任务包',
      stateList: ['待发布', '已发布', '已失效'],
      taskExecuteStateList: ['未开始', '进行中', '已结束'],
      approvalStateList:[  {
          label: '全部',
          value: null
        },
        {
          label: '草稿中',
          value: 'N'
        },
        {
          label: '审批中',
          value: 'A'
        },
        {
          label: '已通过',
          value: 'Y'
        },
        {
          label: '驳回',
          value: 'R'
        },
        {
          label: '已撤销',
          value: 'C'
      }],
      timeRange: '',
      page: {
        staffGuid: userinfo.staffGuid,
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        taskStartTime: '',
        taskEndTime: '',
        taskExecuteState: null,//执行状态
        stateList: [],//任务状态
        approveStateList: [],//审批状态
        taskCategory: null,//任务类别
        productCategoryList: [],//产品类别
        isRelProject: IsRelProjectEnum.ALL,//关联项目
      },
      right: 'right',
      tableData: [],
      sendTenantList: [],
      tenantTagList: [],
      addCustomerTitle:'新增客户',
      taskExecuteTenantList:[],
      projectOption: [],
      projectList: [],
    };
  },
  created() {
    this.getList();
    this.getHeartProject()
  },
  activated() {
    this.getList();
  },
  watch: {
    showMore(val, oldVal) {
      if (val) {
        this.tableHeight = window.innerHeight - 310;
        return;
      }
      if (!val) {
        this.tableHeight = window.innerHeight - 263;
        this.contentMainHeight = window.innerHeight - 200;
        return;
      }
    },
  },
  methods: {
    getHeartProject() {
      this.api.postJson(`/${serverConfig.msSalesPerformService}/platform-task/get-heart-project`).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.projectOption = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    getBillCycleName(list) { 
      
      if (!list||list.length == 0) return '-';
      let namesArray = list.map(item => item.name);
      return namesArray.join('、');
    },
    haveReportFile(row) {
      return Array.isArray(row.reportFileList) &&  row.reportFileList.length ? row.reportFileList[0] : null
    },
    renderHeader: function (h, { column, $index }) {
      return [
        column.label,
        h(
          'el-tooltip',
          {
            props: {
              placement: 'top',
              effect: 'dark',
              //content:"提示框内容",//如果提示内容短不需要换行，直接使用这个提示内容
            },
          },
          [
            h(
              'div',
              {
                //当前div是为了实现换行，就这换行研究了好久。。。
                slot: 'content',
              },
              ['置顶后是针对移动端的任务包排序进行置顶'],
            ),
            h('span', {
              //问号模块
              class: {
                'el-icon-question': true,
              },
            }),
          ],
        ),
      ];
    },
    search() {
      let self = this;
      self.tableLoading = true;
      self.page.pageIndex = 1;
      if (self.timeRange.length != 0) {
        self.page.taskStartTime = self.timeRange[0] + ' ' + '00:00:00';
        self.page.taskEndTime = self.timeRange[1] + ' ' + '23:59:59';
      }
      var req = JSON.parse(JSON.stringify(this.page));
      self.api.postJson(`/${serverConfig.msSalesPerformService}/platform-task/list`, req).then(res => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getList() {
      let self = this;
      let req = JSON.parse(JSON.stringify(this.page));
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/platform-task/list`, req).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },

    addVersion() {
      this.$router.push(`/platformTaskEdit?productGuid=${this.$route.query.productGuid}&is_add=1`);
    },
    delForm(guid) {
      var self = this;
      self
        .$confirm('删除后不可恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          let req = [guid];
          self.api.postJson(`/${serverConfig.msSalesPerformService}/platform-task/del`,req).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('删除成功');
              self.page.pageIndex = 1;
              self.getList();
            } else {
              self.$message.error(res.data.msg);
            }
          });
        });
    },
    emptySearch() {
      let userinfo = JSON.parse(localStorage.userInfo);
      this.page = {
        staffGuid: userinfo.staffGuid,
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        taskStartTime: '',
        taskEndTime: '',
        taskExecuteState: null,//执行状态
        stateList: [],//任务状态
        approveStateList: [],//审批状态
        taskCategory: null,//任务类别
        productCategoryList: [],//产品类别
        isRelProject: IsRelProjectEnum.ALL,//关联项目
      };
      this.timeRange = [];
      this.getList();
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },
    //驳回提交
    toRejectSubmit() {
      if (this.approveSuggest == '') {
        this.$message.error('请填写驳回理由！');
        return;
      }
      let query = {
        guid: this.detail.approveVO.approveGuid,
        flowType: '00028',
        approveSuggest: this.approveSuggest,
        approveStaffGuid: this.staffGuid
      };
      this.fullscreenLoading = true;

      this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/backup-flow`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.rejectDialogVisible = false;
          this.$message.success('驳回成功！');
          this.getList();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //通过
    toPassSubmit() {
      let query = {
        guid: this.detail.approveVO.approveGuid,
        flowType: '00028',
        approveSuggest: this.approveSuggest,
        approveStaffGuid: this.staffGuid
      };
      this.fullscreenLoading = true;
      this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/allow-flow`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.passDialogVisible = false;
          this.$message.success('审批通过！');
          this.getList();
        } else {
          this.$message.error(res.data.msg);
        }
      });

    },
    //撤回
    toRevoke(detail) {
      let self = this;
      this.$confirm('撤销后，该流程将不再进行审核，确定这样操作吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let query = {
          guid: detail.approveVO.approveGuid,
          flowType: '00028',
          approveStaffGuid: this.staffGuid
        };
        self.fullscreenLoading = true;
        self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/canal-flow`, query).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.fullscreenLoading = false;
            self.$message.success('撤销成功！');
            this.getList();
          } else {
            self.$message.error(res.data.msg);
          }
        });
      })
        .catch(() => {
          self.$message({
            type: 'info',
            message: '已取消操作！',
          });
        });
    },
    addCustomer(row){
      let self = this
      this.detail = row
      let time=row.approveVO.createTime
      // let time='2024-02-01'
      let createdTime= moment(time).format('YYYY-MM-DD HH:mm:ss')
      this.addCustomerTitle='新增客户'
      this.tenantTagList = []
      this.sendTenantList = []
      this.projectList = [];
      self.api
        .get(`/${serverConfig.msCustomerService}/tenant-expand/get-new-tenant?createTime=${createdTime}`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let sendTenantList = res.data.data||[];
            //过滤掉之前加过的客户taskExecuteTenantList
            let list=row.taskExecuteTenantList?row.taskExecuteTenantList.filter(item => item.desc == 'Y'):[];
            self.sendTenantList= sendTenantList.filter(item => {
              return(!list.some(otherItem => otherItem.guid === item.tenantGuid)&&item.tenantTag);
            });
            //tenantTag
          } else {
            self.$message.error(res.data.msg);
          }
          this.addDialogVisible=true
        });
    },
    seeCustomer(row){
      let self = this
      this.detail = row
      var req = {
        guid: row.guid,
      };
      this.addCustomerTitle='查看新增客户'
      this.tableLoading = true;
      self.api.get(`/${serverConfig.msSalesPerformService}/platform-task/detail`, req).then((res) => {
        this.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          var detail = res.data.data;
          this.taskExecuteTenantList = detail.taskExecuteTenantList.filter(item => item.desc == 'Y');
          console.log('taskExecuteTenantList',this.taskExecuteTenantList);
          
          this.addDialogVisible=true          
        } else {
          self.$message.error(res.data.msg);
        }
      });
      
      
        
    },
    //查看
    seeForm(detail,type) {
      if(type==1){
        this.$router.push(`/platformTaskEdit?guid=${detail.guid}&productGuid=${this.$route.query.productGuid}&is_detail=1`); //查看
      }
      if(type==2){
        this.$router.push('/platformTaskDetail?guid=' + detail.guid + '&productGuid=' + this.$route.query.productGuid); //查看
      }
    
    },
    //新增客户变更
    toAddSubmit() {
      console.log('this.tenantTagList',this.tenantTagList)
      // if(this.tenantTagList.length<1){
      //   this.$message.error('请选择客户！');
      //   return;
      // }
      if (this.tenantTagList.length < 1 && this.projectList.length < 1) { 
        // 二选一
        this.$message.error('请至少选择一项内容填写');
        return;
      }
      let result = [];
      this.tenantTagList.forEach(item => {
        // 在sendTenantList数组中查找guid匹配的对象
        let obj = this.sendTenantList.find(obj => obj.tenantGuid === item);
        if (obj) {
          const newObj = {
            guid:obj.tenantGuid,
            name:obj.tenantTag,
            desc:'Y'
          };
          result.push(newObj);
        }
      });
      const projectList = this.projectOption.filter(item => this.projectList.includes(item.guid))
      let query = {
        // ...this.detail,
        guid: this.detail.guid,
        taskExecuteTenantList: result,
        projectList,
      };

      this.fullscreenLoading = true;
      this.api.postJson(`/${serverConfig.msSalesPerformService}/platform-task/update-tenant`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.addDialogVisible = false;
          this.projectList = [];
          this.$message.success('变更成功！');
          this.getList();
        } else {
          this.$message.error(res.data.msg);
        }
      });

    },
    //编辑
    editForm(detail) {
      this.$router.push({
        path: '/platformTaskEdit',
        query: {
          guid: detail.guid,
          is_edit: 1,
          productGuid: this.$route.query.productGuid,
        }
      })
    },
    //设为失效
    setIvalidityState(detail) {
      let self = this;
      this.$confirm('设为失后，该任务将不可执行，确定这样操作吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        self.fullscreenLoading = true;
        self.api.postJson(`/${serverConfig.msSalesPerformService}/platform-task/update-filed-state?guid=${detail.guid}&handleType=1`).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.fullscreenLoading = false;
            self.$message.success('操作成功！');
            this.getList();
          } else {
            self.$message.error(res.data.msg);
          }
        });
      })
        .catch(() => {
          self.$message({
            type: 'info',
            message: '已取消操作！',
          });
        });

    },
    //设为/取消置顶
    setTop(guid, isTop) {
      let self = this;
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/platform-task/update-filed-state?guid=${guid}&handleType=2&filedState=${isTop}`).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.fullscreenLoading = false;
          self.$message.success('操作成功！');
          this.getList();
        } else {
          self.$message.error(res.data.msg);
        }
      });

    },
    //上传运营报告相关
    openReportDialog(detail){
      this.reportDialogVisible = true;
      let reportFileList = [];
      if(!detail.reportFileList){
        detail.reportFileList = [];
        this.detail = detail;
        return;
      }
      console.log( detail.reportFileList)
      detail.reportFileList.forEach(item=>{
        reportFileList.push({
          name:item.fileName||item.name,
          path:item.path
        })
      })
      detail.reportFileList = reportFileList;
      console.log( detail.reportFileList)
      this.detail = detail;

    },
    handleExceed(files) {
      this.$message.warning(`当前限制选择 1 个文件`);
    },
    handleRemove(file) {
      this.detail.reportFileList.forEach((j, ind)=> {
        if (j.path == file.path) {
          this.detail.reportFileList.splice(ind, 1);
        }
      });
    },
    onPreview(file) {
      var fileSuffix = file.name ? file.name.substring(file.name.lastIndexOf('.') + 1) : '';
      if (fileSuffix === 'png' || fileSuffix === 'jpeg' || fileSuffix === 'jpg' || fileSuffix === 'pdf' || fileSuffix === 'zip') {
        return window.open(file.path, file.name);
      }
      window.open('https://view.officeapps.live.com/op/view.aspx?src=' + file.path);
    },
    onDownload(file) {
      window.open(file.path + '?response-content-type=application/octet-stream');
    },
    //上传限制
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isLt2M) {
        this.$message({
          message: `上传文件大小不能超过 20MB!`,
          type: 'warning',
        });
      }
      return isLt2M;
    },
    uploadFile(file) {
      let self = this;
      let formData = new FormData();
      self.detail.reportFileList = [];
      formData.append('image', file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let item = {
              name: file.file.name,
              path: res.data.data,
            };
            self.detail.reportFileList.push(item);
            self.$message.success('上传成功');
          } else {
            self.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },
    uploadReport() {
      if (!this.detail.reportFileList || !this.detail.reportFileList.length) return this.$message.error('请上传运营报告!');
      let reportFileList = this.detail.reportFileList;
      let newList = [];
      reportFileList.forEach(item => {
        newList.push({
          fileName: item.name,
          path: item.path
        })
      })
      this.fullscreenLoading = true;
      this.api.postJson(`/${serverConfig.msSalesPerformService}/platform-task/upload-report-file?guid=${this.detail.guid}`, newList).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.reportDialogVisible = false;
          this.$message.success('上传成功！');
          this.getList();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    }
  }
};
</script> 
<style scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}

/deep/ .el-checkbox__label {
  display: none;
}

.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}

.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}

/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}

/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}

/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}

.search-area-div {
  width: 60px;
}
.w90 {
  width: 90px;
}
.file-operate {
  display: flex;
}
.file-preview {
  margin-left: 10px;
  cursor: pointer;
  text-decoration: underline;
  cursor: pointer;
  color: #4fa1a4;
}
.import-step-tip{
  color: #999;
  line-height: 25px;
  font-size: 12px;
}
</style>